// 아무도 잡지 않은 에러가 흐르는 브라우저 통로는 window 의 error·unhandledrejection 둘뿐이다.
// SDK 자동 수집 대신 여기서 직접 받아 reporter 로 넘겨야 판정이 파이프라인 한 곳에서만 일어난다.
// 값은 가공하지 않는다 — 문자열·객체·DOMException 처리는 toAppError 의 몫이다.

import type { ErrorReporter } from './reporter'

type Capture = Pick<ErrorReporter, 'capture'>

// 리스너 안에서 예외가 새면 브라우저가 "에러 처리 중 에러" 로 보고해 원인이 묻힌다.
const guarded = (run: () => void) => {
  try {
    run()
  } catch {
    // reporter 의 safely 가 이미 막지만, 다른 구현이 꽂혀도 리스너는 조용해야 한다
  }
}

export const installGlobalHandlers = (reporter: Capture): (() => void) => {
  const onError = (event: ErrorEvent) =>
    guarded(() => reporter.capture(event.error ?? event.message, { mechanism: 'onerror' }))
  const onRejection = (event: Event) =>
    guarded(() =>
      reporter.capture((event as PromiseRejectionEvent).reason, {
        mechanism: 'unhandledrejection',
      }),
    )

  window.addEventListener('error', onError)
  window.addEventListener('unhandledrejection', onRejection)

  return () => {
    window.removeEventListener('error', onError)
    window.removeEventListener('unhandledrejection', onRejection)
  }
}
